import { Part } from "components/styles";
import UploadFileBlock from "../../../../components/UploadFileBlock/UploadFileBlock";

const ModifyFile = ({
    file,
    changeForm, 
    errors
}) => {
    //#region Functions
    const changeFileData = (newFile) => {
        changeForm({ ...newFile });
    }
    //#endregion
    return (
        <Part>
            <UploadFileBlock 
                title="Modifica tu archivo para poder continuar y finalizar tu carga masiva"
                file={file}
                errors={errors}
                changeForm={changeFileData}
            />
        </Part>
    );
}

export default ModifyFile;